<template>
  <div class="popup">
    <Popup v-model="show" position="left" class="vant-popup">
      <div class="box">
        <h5 class="All" @click="All" :style="sel_all && 'color:#e42129'">全部商品</h5>
        <div
          class="sort"
          :style="!item.flag && 'height:auto;'"
          v-for="(item,index) in cateData"
          :key="item.id"
          @click="openParent(item.id,index)"
        >
          <div class="title">
            <h5 :style="(selId == item.id || !item.flag) && 'color:#e42129'">{{ item.title }}</h5>
            <img :src="item.flag ? imgList[0]:imgList[1]" v-if="item._child.length != 0" />
          </div>
          <h6
            :style="(el.id == seliid ) && 'color:#e42129' "
            v-for="el in item._child"
            :key="el.id"
            @click="subset(item.id,el.id)"
          >{{ el.title }}</h6>
        </div>
        <div class="sure">
          <div class="clear" @click="cancel">取消</div>
          <div class="enter" @click="comfirm">确定</div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<style lang="less" scoped>
.popup {
  // position: fixed;
  // width: 100%;
  // height: 100%;
  // box-sizing: border-box;
  // z-index: 10;
  // top: 0;
  // left: -2000px;
  // overflow: hidden;
  // background-color: rgba(0, 0, 0, 0.6);
  .vant-popup {
    width: 450px;
    height: 100%;
  }

  .box {
    background-color: #fff;
    width: 400px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    padding: 0 24px;
    .All {
      font-size: 32px;
      color: #333;
      height: 100px;
      line-height: 100px;
    }
    .sort {
      height: 100px;
      overflow: hidden;
      border-bottom: 1px solid #eee;

      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100px;
        h5 {
          font-size: 30px;
          color: #333;
          margin: 20px 0;
          font-weight: 500;
        }
        img {
          width: 30px;
          // height: 40px;
        }
      }
      h6 {
        font-size: 28px;
        color: #333;
        font-weight: 400;
        margin: 15px 30px;
      }
    }
    .sure {
      position: absolute;
      bottom: 0px;
      left: 0;
      height: 100px;
      width: 100%;
      display: flex;
      align-items: center;
      font-size: 30px;
      // border-top: 1Px solid #eee;
      box-sizing: border-box;
      .clear {
        flex: 1;
        line-height: 100px;
        text-align: center;
        color: #333;
        background-color: #fff;
        border-top: 1px solid #eee;
        box-sizing: border-box;
      }
      .enter {
        flex: 1;
        line-height: 100px;
        text-align: center;
        color: #fff;
        background-color: #e42129;
      }
    }
  }
}
</style>
<script>
import { Popup } from "vant";

export default {
  data() {
    return {
      imgList: [
        require("../../assets/shop/zhankai.png"),
        require("../../assets/shop/shouqi.png")
      ],
      selId: null,
      seliid: null,
      show: false,
      sel_all: false
    };
  },
  components: {
    Popup
  },
  computed: {
    cateData() {
      return this.$store.state.cate;
    }
  },
  methods: {
    setShow() {
      this.show = true;
    },
    openParent(id, index) {
      this.selId = id;
      this.sel_all = false;
      let cate = this.cateData;

      cate.forEach(item => (item.flag = true));

      cate[index].flag = !cate[index].flag;

      this.$store.commit("setCate", cate);

      if (!cate[index]._child.length) this.seliid = null;
    },
    subset(id, iid) {
      let cate = this.cateData;
      let index = cate.findIndex(item => item.id == id);
      console.log(index);
      let i = null;
      if (cate[index]._child) {
        cate[index]._child.forEach((item, index) => {
          item.flag = false;
          if (item.id == iid) i = index;
        });
      }
      this.seliid = iid;

      this.$store.commit("setCate", cate);
      this.selId = "";
      this.seliid = "";
      this.comfirm();
    },
    cancel() {
      this.show = false;
    },
    comfirm() {
      let seliid = this.seliid;
      let selId = this.selId;
      if (seliid) {
        // this.$parent.setCate_id(seliid);
        this.$emit("setCate_id", seliid);
        this.selId = "";
        this.seliid = "";
      } else {
        // this.$parent.setCate_id(selId);
        this.$emit("setCate_id", selId);
        this.selId = "";
        this.seliid = "";
      }

      this.show = false;
    },
    All() {
      let cate = this.cateData;
      this.sel_all = true;
      this.selId = "";
      cate.forEach(item => (item.flag = true));
      this.$store.commit("setCate", cate);
      this.show = false;
      // this.$parent.setCate_id("");
      this.$emit("setCate_id", "");
      this.selId = "";
      this.seliid = "";
    }
  }
};
</script>
